import React from "react";

export default function AboutHero() {
  return (
    <section className="about-hero">
      <div className="sobre-container">
        <h1 className="font-nunito">Adoçando a vida, um pedido de cada vez.</h1>
        <p>
          Nascemos da paixão por doces e do desejo de conectar os melhores
          confeiteiros artesanais diretamente a você.
        </p>
      </div>
    </section>
  );
}
